module.exports = __webpack_public_path__ + "media/components/homepage/static/wave-8efc5ef68ad2ca6d346b2a71e210c732.png";